export default __webpack_public_path__ + "static/media/help.38efe960.svg";